import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[stop-click-propagation]'
})
export class StopClickPropagationDirective {
  constructor() {}

  @HostListener('click', ['$event'])
  @HostListener('keydown.Enter', ['$event'])
  @HostListener('keydown.Space', ['$event'])
  stopPropagationHandler(event: Event): void {
    event.stopPropagation();
  }
}
